module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/first.js
// module id = 2417
// module chunks = 0